import RsaDynamicBodyAreaPage from "./pages/RsaDynamicBodyAreaPage.vue";
export default {
RsaDynamicBodyAreaPage
};
